<app-pay-out *ngIf="english"></app-pay-out>
<app-payout-hindi *ngIf="hindi"></app-payout-hindi>